<template>
  <div>
<!--  <SearchInfoDialog :visible="searchInfoDialog.visible"-->
<!--                    @cancelEvent="searchInfoDialog.cancel">-->
<!--  </SearchInfoDialog>-->
<!--    <v-layout class="mb-2" v-if="this.$route.query.agentId && this.$route.query.agentId !==''">-->
<!--      <v-flex xs12>-->
<!--        <v-btn color="blue" dark text @click="showSearchInfoDialog()"-->
<!--        >查詢進件次數</v-btn>-->
<!--      </v-flex>-->
<!--    </v-layout>-->

    <edit-installment-product-view
      v-if="caseCategory === 0 && isShowCreditPage"
      :loading="loading"
      :loading-text="loadingText"
      :cellphone="cellphone"
      :isSaveSuccess="isSaveSuccess"
      :editedIndex="editedIndex"
      @saveData="save"
    ></edit-installment-product-view>
    <edit-credit-product-view
      v-if="caseCategory === 1"
      :loading="loading"
      :editedIndex="editedIndex"
      :isSaveSuccess="isSaveSuccess"
      @saveData="save"
    ></edit-credit-product-view>
    <edit-c-a-product-view
      v-if="caseCategory === 2"
      :loading="loading"
      :editedIndex="editedIndex"
      :isSaveSuccess="isSaveSuccess"
      :platform="platform"
      @saveData="caSave"
    ></edit-c-a-product-view>
    <!-- <edit-c-a-product-from
      v-if="caseCategory === 2 && isShowCreditPage"
      :loading="loading"
      :editedIndex="editedIndex"
      :isSaveSuccess="isSaveSuccess"
      @saveData="caSave"
    ></edit-c-a-product-from> -->
    <edit-installment-product-from
      v-if="caseCategory === 3 && isShowCreditPage"
      :loading="loading"
      :loading-text="loadingText"
      :cellphone="cellphone"
      :isSaveSuccess="isSaveSuccess"
      :editedIndex="editedIndex"
      @saveData="save"
    ></edit-installment-product-from>
    <!-- <loanhfc-edit-view v-else-if="caseCategory === 4"></loanhfc-edit-view> -->
    <loanhfc-v202105-edit-view v-else-if="caseCategory === 4"></loanhfc-v202105-edit-view>
    <entrepreneur-view
      v-else-if="caseCategory === 5"
      :loading="loading"
      :editedIndex="editedIndex"
      :isSaveSuccess="isSaveSuccess"
      @saveData="save"
    ></entrepreneur-view>
    <finatrade-edit-view
      v-else-if="caseCategory === 6"
      :loading="loading"
      :editedIndex="editedIndex"
      :isSaveSuccess="isSaveSuccess"
      @saveData="save"
    ></finatrade-edit-view>
    <alert-view :visible="messageDialog.visible"
                  :title="messageDialog.title"
                  :content="messageDialog.text"
                  @confirmEvent="messageDialog.confirm">
                </alert-view>
  </div>
</template>

<script>
import { getNow } from "@/pages/utils/tool";
import MobileDetect from "mobile-detect";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import EditInstallmentProductView from "./EditInstallmentProductView";
import EditCreditProductView from "./EditCreditProductView";
import EditCAProductView from "./EditCAProductView";
import EntrepreneurView from "./EntrepreneurView";
import EditInstallmentProductFrom from "./EditInstallmentProductFrom";
import EditCAProductFrom from "./EditCAProductFrom";
import loanhfcEditView from "./loanhfcEditView";
import loanhfcV202105EditView from "./loanhfcV202105EditView"
import FinatradeEditView from "./FinatradeEditView";
import AlertView from '@/components/AlertView'
import common from '../../mixins/common';
// import SearchInfoDialog from '@/components/SearchInfoDialog';
const md = new MobileDetect(window.navigator.userAgent);
export default {
  name: "EditCreditProduct",
  components: {
    EditInstallmentProductView,
    EditCreditProductView,
    EditCAProductView,
    EditInstallmentProductFrom,
    loanhfcEditView,
    loanhfcV202105EditView,
    EntrepreneurView,
    FinatradeEditView,
    EditCAProductFrom,
    AlertView,
    // SearchInfoDialog
  },
  data() {
    return {
      isSaveSuccess: false,
      creditPriceData: require("../../assets/credit_price"),
      cityData: require("../../assets/taiwan_city"),
      cityList: [],
      areaList: {},
      loading: false,
      valid: true,
      dialog: false,
      editedIndex: -1,
      caseCategory: -1,
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancel: false,
        confirm: () => {},
        cancel: () => {},
      },
      items: [],
      showBackButton: false,
      agent: {},
      cellphone: "",
      loadingText: "",
      isShowCreditPage: false,
      syncToken: "",
      platform:0,
      isNew:false,
      isCaList:false,
      searchInfoDialog: {
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
    };
  },
  created() {
    document.title = "數位線上資融進件平台";

    const description = document.createElement("meta");
    description.name = "description";
    description.content = "數位線上資融進件平台";
    document.head.appendChild(description);

    const caseCategory = parseInt(this.$route.query.caseCategory, 10);
    const editIndex = this.$route.query.editIndex;
    const showBackButton = this.$route.query.enable;
    const agentId = this.$route.query.agentId;
    this.platform = parseInt(this.$route.query.platform) || 0;
    this.isNew = !!parseInt(this.$route.query.isNew);
    this.isCaList = !!parseInt(this.$route.query.isCaList);
    console.log(
      `editedIndex == ${caseCategory} ,${editIndex} , ${showBackButton} , ${agentId} this.platform === ${this.platform}`
    );
    if (agentId) {
      this.fetchAgentInfo(agentId);
    }

    this.$set(this, "caseCategory", caseCategory);
    this.$set(this, "editedIndex", parseInt(editIndex, 10));
    this.editedIndex = parseInt(editIndex, 10);

    this.isShowCreditPage = true;
    // if (this.editedIndex === 0){ //編輯
    //     this.isShowCreditPage = true;
    // }

    // this.type = enable;
    this.$set(this, "showBackButton", showBackButton);

    window.onbeforeunload = function () {
      return "確定要離開嗎？";
    };
  },
  mounted() {
    if (this.$route.query.enable !== undefined) {
      const enable = this.$route.query.enable === "true";
      this.$set(this, "type", enable);
    }
  },
  mixins:[common],
  computed: {
    ...mapGetters(["getAgentList"]),
    isShowBackButton() {
      console.log(`getType == ${this.showBackButton}`);
      return this.showBackButton;
    },
  },
  methods: {
    ...mapActions([
      "fetchAgentList",
      "saveCreditProduct",
      "configAgentInfo",
      "saveFinanceCreditData",
      "saveFinanceInfo",
      "loginAgentService",
      "saveFinanceSignImage",
      "uploadImageData",
      "caCreate",
      "caUpdate"
    ]),
    showSearchInfoDialog(){
      this.searchInfoDialog.visible = true;
      this.searchInfoDialog.cancel = ()=>{
        this.searchInfoDialog.visible = false;
      }
    },
    fetchAgentInfo(agentId) {
      this.loading = true;
      this.loadingText = "載入中...";
      const api =
        "https://us-central1-chiahao-92b7e.cloudfunctions.net/fetchAgentInfo";
      axios({
        method: "post",
        url: api,
        data: {
          agentId: agentId || "",
        },
      }).then(async (response) => {
          this.loading = false;
          const result = response.data;
          if (result.code === 200) {
            this.agent = result.data[0];
            console.log(`agent = ${JSON.stringify(this.agent)}`);
            this.configAgentInfo(this.agent);

            const loginResult = await this.loginAgentService({
              email: this.agent.email,
            });
            if (loginResult.data) {
              this.syncToken = loginResult.data.data.token;
              console.log(`sync token == ${this.syncToken}`);
            }
          }
        })
        .catch((error) => {
          this.loading = false;
          console.log(`fetchAgentInfo = ${JSON.stringify(error)}`);
        });
    },
    async caSave(item) {
      // if(this.platform===0 && !!item.header.caType[0].value)
      // {
        if(this.isNew) {
          item.caseId = Math.uuidFast();
          item.displayId = "";
          item.category = 2;
        }

        this.save(item);
      //   return;
      // }
      // const isSuccess = await this.saveItem(item, true);
      // if (isSuccess) {
      //   this.showMessageDialog(
      //         "申辦成功",
      //         "請申辦人三個小時之內，注意接聽照會電話。",
      //         true,
      //         () => {},
      //         () => {}
      //       );
      // } else {
      //   this.showMessageDialog(
      //         "申辦失敗",
      //         "請洽工程人員處理。",
      //         true,
      //         () => {},
      //         () => {}
      //       );
      // }
    },
    async save(item) {
      // console.log(`save === ${JSON.stringify(item)}`);
      const isSuccess = await this.saveItem(item);
      this.loading = false;
      if (!isSuccess) {
        return;
      }
      const copySignImage = {
        caseId: item.caseId,
        signImage0: item.signImage0,
        signImage1: item.signImage1,
        signImage2: item.signImage2,
        signImage3: item.signImage3,
      };

      delete item.signImage0;
      delete item.signImage1;
      delete item.signImage2;
      delete item.signImage3;

      this.loadingText = "儲存中...";
      const api =
        "https://us-central1-chiahao-92b7e.cloudfunctions.net/saveFinanceUserInfo";
      axios({
        method: "post",
        url: api,
        data: item,
        timeout: 20 * 1000,
      })
        .then(async (response) => {
          // console.log(`result = ${JSON.stringify(response.data)}`);
          const result = response.data;
          if (result.code === 200) {
            const result = await this.saveFinanceSignImage(copySignImage);

            item.signImage0 = copySignImage.signImage0;
            item.signImage1 = copySignImage.signImage1;
            item.signImage2 = copySignImage.signImage2;
            item.signImage3 = copySignImage.signImage3;

            this.loading = false;
            this.isSaveSuccess = true;
            console.log(`update signImage = ${JSON.stringify(result)}`);
            this.messageDialog.showCancel = false;
            this.showMessageDialog(
              "申辦成功",
              "請申辦人三個小時之內，注意接聽照會電話。另請上傳附加圖片檔！",
              true,
              () => {},
              () => {}
            );
          } else {
            this.loading = false;
            this.search.message = "查無資料！";
            this.messageDialog.showCancel = true;
            this.showMessageDialog(
              "提示",
              `儲存失敗！${JSON.stringify(result)}，請聯繫資訊人員。`,
              true,
              () => {},
              () => {}
            );
          }
        })
        .catch((error) => {
          this.loading = false;
          this.messageDialog.showCancel = true;
          this.showMessageDialog(
            "發生錯誤",
            `儲存失敗！${error.message}，請聯繫資訊人員。`,
            true,
            () => {},
            () => {}
          );
        });
    },
    async saveItem(item, caStatus = false) {
      const editIndex = parseInt(this.$route.query.editIndex, 10);
      console.log(`saveItem editIndex === ${editIndex}`);
      if (editIndex === -1) {
        console.log(`this.agent === ${JSON.stringify(this.agent)}`);
        if (!this.agent) {
          this.showMessageDialog(
            "發生錯誤",
            `查無經銷帳號，請確認網址是否有誤或聯繫客服人員。`,
            true,
            () => {},
            () => {}
          );
          return;
        }
        item.parentAgent = {
          agentId: this.agent.agentId
            ? this.agent.agentId
            : "Yd2Xn5V5xldYmGZbCvlK8bmfFHJ2",
          agentNumber: this.agent.agentNumber
            ? this.agent.agentNumber
            : "000000",
          displayName: this.agent.displayName
            ? this.agent.displayName
            : "總公司",
          parentAgent: {
            agentId: this.agent.parentAgent
              ? this.agent.parentAgent.agentId
              : "Yd2Xn5V5xldYmGZbCvlK8bmfFHJ2",
            rootAgent: "Yd2Xn5V5xldYmGZbCvlK8bmfFHJ2",
          },
          salesName: this.agent.salesName ? this.agent.salesName : "總公司",
        };
      }

      if (!item.parentAgent){
        item.parentAgent = {
          agentId: this.agent.agentId
            ? this.agent.agentId
            : "Yd2Xn5V5xldYmGZbCvlK8bmfFHJ2",
          agentNumber: this.agent.agentNumber
            ? this.agent.agentNumber
            : "000000",
          displayName: this.agent.displayName
            ? this.agent.displayName
            : "總公司",
          parentAgent: {
            agentId: this.agent.parentAgent
              ? this.agent.parentAgent.agentId
              : "Yd2Xn5V5xldYmGZbCvlK8bmfFHJ2",
            rootAgent: "Yd2Xn5V5xldYmGZbCvlK8bmfFHJ2",
          },
          salesName: this.agent.salesName ? this.agent.salesName : "總公司",
        };
      }

      // console.log(`agent  === ${JSON.stringify(this.agent)}`);
      console.log(`save === ${JSON.stringify(item)}`);
      item.updateDate = getNow();
      this.loading = true;

      try {
        const copy = JSON.parse(JSON.stringify(item));
        let signList = [
          copy.signImage0,
          copy.signImage1,
          copy.signImage2,
          copy.signImage3,
        ];
        let i = 0;
        for (let image of signList) {
          if (image && image !== "") {
            //儲存簽名
            const urlPath = await this.uploadImageData({
              name: Math.uuidFast(),
              image: image,
            });

            switch (i) {
              case 0:
                copy.signImage0Url = urlPath;
                break;
              case 1:
                copy.signImage1Url = urlPath;
                break;
              case 2:
                copy.signImage2Url = urlPath;
                break;
              case 3:
                copy.signImage3Url = urlPath;
                break;
            }
          }
          i += 1;
        }

        const token = this.syncToken;
        console.log(`sync to mysql == ${token}`);
        copy.token = token;
        delete copy.signImage0;
        delete copy.signImage1;
        delete copy.signImage2;
        delete copy.signImage3;
        let results = {};
        if (caStatus) {
          if(editIndex === -1) {
            results = await this.caCreate(copy);
            console.log(`create result === ${JSON.stringify(results)}`)
          } else {
            results = await this.caUpdate(copy);
            console.log(`update result === ${JSON.stringify(results)}`)
          }
        } else {
          await this.saveFinanceInfo(copy);
        }

        if(results.name === "Error") {
          return false;
        }

        return true;
      } catch (e) {
        this.showMessageDialog(
          "提示",
          `儲存失敗！${e}，請聯繫資訊人員。`,
          true,
          () => {},
          () => {}
        );
        return false;
      }
    },
    back() {
      this.$router.back();
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.loading = false;
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/web/EditCreditProduct.vue